import PropTypes from "prop-types";

export function authAccess_asiakas(asiakas, user, userAsiakas) {
  return authAccess_asiakas_global(asiakas, user, userAsiakas);
  // if keikkaId is null, then check for globalAsiakas access
  //   if (keikkaId == null) {
  //     return authAccess_asiakas_global(asiakas, user, userAsiakas);
  //   } else {
  //     return authAccess_asiakas_keikka(asiakas, keikkaId, user, userAsiakas);
  //   }
}

function authAccess_asiakas_global(asiakas, user, userAsiakas) {
  let response = {
    read: false,
    edit: false,
    tarjous: { read: false, edit: false },
    lasku: { read: false, edit: false },
    roles: { read: false, edit: false },
  };
  if (!user || !asiakas) return response;
  if (
    user.personId == asiakas.asiakasContactPersonId ||
    userAsiakas.asiakasId === asiakas.asiakasId ||
    asiakas.auth.edit ||
    asiakas.auth.originalEdit
  )
    response.read = true;

  if (userAsiakas.auth.isAsiakasEditor || userAsiakas.auth.isKeikkaHandler) {
    response.read = true;
    response.edit = true;
  }
  if (userAsiakas.auth.isAsiakasAdmin) {
    if (user.isRoleManager) {
      response.roles.read = true;
      response.roles.edit = true;
    }
    response.read = true;
    response.edit = true;
    response.tarjous.read = true;
    response.tarjous.edit = true;
    response.lasku.read = true;
    response.lasku.edit = true;
    return response;
  }
  if (asiakas.auth.isTarjousAdmin) {
    response.tarjous.read = true;
    response.tarjous.edit = true;
  }
  if (asiakas.auth.isLaskuAdmin) {
    response.lasku.read = true;
    response.lasku.edit = true;
  }
  if (user.isKeikkaAdmin) {
    if (user.asiakasListContains(asiakas.ownerAsiakasId)) {
      response.read = true;
      response.edit = true;
    }
  }
  if (asiakas.auth.read) return (response.read = true);
  return response;
}

function authAccess_asiakas_keikka(asiakas, keikkaId, user, userAsiakas) {}

authAccess_asiakas.propTypes = {
  asiakas: PropTypes.object,
  keikkaId: PropTypes.number,
  user: PropTypes.object,
  userAsiakas: PropTypes.object,
};
